import '../css/ruta.scss'
import icon_barco from '../assets/images/icons/barco-icon.png'

export default function Ruta({
    route,
    onChangeRoute,
    onChangeSection,
    activeSection
}) {

  return (
    <section className='ruta'>
        <div className='container'>
            <div>

                <div className='select-ruta'>
                    <img src={icon_barco} alt='selecciona la ruta' />

                    <select
                        value={route}
                        onChange={(e) => onChangeRoute(e.target.value)} >
                        <option value="lpz-topo">
                            La Paz - Topolobampo
                        </option>

                        <option value="topo-lpz">
                            Topolobampo - La Paz
                        </option>

                        <option value="lpz-mzt">
                            La Paz - Mazatlán
                        </option>

                        <option value="mzt-lpz">
                            Mazatlán - La Paz
                        </option>
                    </select>
                </div>

                <hr />

                <div className='ruta-buttons-content'>
                    <div className='ruta-buttons'>

                        <button
                            className={activeSection === "antes" ? "active" : ""}
                            onClick={() => onChangeSection("antes")}
                        >
                            Antes de viajar
                        </button>

                        <button
                            className={activeSection === "durante" ? "active" : ""}
                            onClick={() => onChangeSection("durante")}
                        >
                            Durante tu viaje
                        </button>

                        <button
                            className={activeSection === "despues" ? "active" : ""}
                            onClick={() => onChangeSection("despues")}
                        >
                            Al llegar
                        </button>

                    </div>
                </div>

            </div>
        </div>
    </section>
  )
}